import { memo } from "react";

function ProductWater() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28 5.13524C27.93 5.1456 27.861 5.15652 27.793 5.16797C26.0944 5.45382 25.0259 6.09107 24.1104 6.49512C23.2165 6.88953 22.136 7.25 20 7.25C17.4847 7.25 16.3508 6.75349 15.2373 6.24023C13.9692 5.65573 12.6442 5 10 5C7.35575 5 6.03076 5.65573 4.7627 6.24023C3.64921 6.75349 2.51526 7.25 0 7.25V9.75C2.98461 9.75 4.48247 9.12148 5.80957 8.50977C6.98193 7.96936 7.90708 7.5 10 7.5C12.0929 7.5 13.0181 7.96936 14.1904 8.50977C15.5175 9.12148 17.0154 9.75 20 9.75C22.4965 9.75 23.9201 9.31181 25.1201 8.78223C26.2336 8.29083 26.8451 7.89597 28 7.6704V5.13524Z"
        fill="currentColor"
      />
      <path
        d="M28 12.1352C27.93 12.1456 27.861 12.1565 27.793 12.168C26.0944 12.4538 25.0259 13.0911 24.1104 13.4951C23.2165 13.8895 22.136 14.25 20 14.25C17.4847 14.25 16.3508 13.7535 15.2373 13.2402C13.9692 12.6557 12.6442 12 10 12C7.35575 12 6.03076 12.6557 4.7627 13.2402C3.64921 13.7535 2.51526 14.25 0 14.25V16.75C2.98461 16.75 4.48247 16.1215 5.80957 15.5098C6.98193 14.9694 7.90708 14.5 10 14.5C12.0929 14.5 13.0181 14.9694 14.1904 15.5098C15.5175 16.1215 17.0154 16.75 20 16.75C22.4965 16.75 23.9201 16.3118 25.1201 15.7822C26.2336 15.2908 26.8451 14.896 28 14.6704V12.1352Z"
        fill="currentColor"
      />
      <path
        d="M28 19.1352C27.93 19.1456 27.861 19.1565 27.793 19.168C26.0944 19.4538 25.0259 20.0911 24.1104 20.4951C23.2165 20.8895 22.136 21.25 20 21.25C17.4847 21.25 16.3508 20.7535 15.2373 20.2402C13.9692 19.6557 12.6442 19 10 19C7.35575 19 6.03076 19.6557 4.7627 20.2402C3.64921 20.7535 2.51526 21.25 0 21.25V23.75C2.98461 23.75 4.48247 23.1215 5.80957 22.5098C6.98193 21.9694 7.90708 21.5 10 21.5C12.0929 21.5 13.0181 21.9694 14.1904 22.5098C15.5175 23.1215 17.0154 23.75 20 23.75C22.4965 23.75 23.9201 23.3118 25.1201 22.7822C26.2336 22.2908 26.8451 21.896 28 21.6704V19.1352Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(ProductWater);
